module.exports = __webpack_public_path__ + "static/media/lojaintegrada-card-big.9dd26ef5.png";